const goodsList=[
  {value: '0110001', label: '褐煤'},
  {value: '0110002', label: '炼焦烟煤'},
  {value: '0110003', label: '无烟煤'},
  {value: '0110004', label: '一般烟媒'},
  {value: '0110005', label: '原煤'},
  {value: '0110006', label: '烟煤'},
  {value: '0120001', label: '炼焦精煤'},
  {value: '0120002', label: '洗精煤'},
  {value: '0130001', label: '褐块煤'},
  {value: '0130002', label: '块煤'},
  {value: '0130003', label: '筛选块煤'},
  {value: '0130004', label: '无烟块煤'},
  {value: '0130005', label: '洗块煤'},
  {value: '0130006', label: '烟块煤'},
  {value: '0140001', label: '粉煤'},
  {value: '0140002', label: '末煤'},
  {value: '0140003', label: '煤泥'},
  {value: '0140004', label: '筛选粉煤'},
  {value: '0140005', label: '筛选混煤'},
  {value: '0140006', label: '筛选煤'},
  {value: '0140007', label: '筛选末煤'},
  {value: '0140008', label: '洗粉煤'},
  {value: '0140009', label: '洗混煤'},
  {value: '0140010', label: '洗煤'},
  {value: '0140011', label: '洗末煤'},
  {value: '0140012', label: '洗选煤'},
  {value: '0140013', label: '洗原煤'},
  {value: '0140014', label: '洗中煤'},
  {value: '0150001', label: '水煤浆'},
  {value: '0190001', label: '风化煤'},
  {value: '0190002', label: '蜂窝煤'},
  {value: '0190004', label: '红煤粉'},
  {value: '0190005', label: '煤饼'},
  {value: '0190006', label: '煤粉'},
  {value: '0190007', label: '煤球'},
  {value: '0190008', label: '煤砖'},
  {value: '0190009', label: '煤制品'}
];

const formRules={
  //用户名
  userIdReg:/^[A-Za-z0-9]{2,20}$/,
  //密码
  passwordReg:/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){6,20}$/,
  //两位小数
  numberTwoPointReg:/^[0-9]+(.[0-9]{1,2})?$/,
  //手机号
  mobilePhoneReg:/^[1][3,4,5,6,7,8,9][0-9]{9}$/,
  //15-18身份证
  IDCardReg:/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
  //com.cn或者com
  emailReg:/^\w+@[a-z0-9]+\.(com)|(com.cn)$/,
  //必须为数字
  numberReg:/^\d+$$/,
  //联系电话（手机、可带分机号的座机）
  phoneReg:/((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{6}|\d{5}|\d{4}|\d{3}|\d{2}|\d{1}))$)/,
  //联系电话（可带分机号的座机）
  telphoneReg:/(^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{6}|\d{5}|\d{4}|\d{3}|\d{2}|\d{1}))$)/,
  //验证码
  tokenReg:/^[A-Za-z0-9]{4}$/,
  //需求单号
  demandReg:/^[A-Za-z0-9]{15}$/
}


export default
{
  goodsList,
  formRules,
}
